import {Component, Input, OnInit} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TablePulseAbstractComponent} from '../../table-pulse-abstract/table-pulse-abstract.component';

@Component({
  selector: 'app-table-pulse-status',
  templateUrl: './table-pulse-status.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TablePulseStatusComponent extends TablePulseAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

  ngOnInit(): void {
  }
}
